module.exports = __webpack_public_path__ + "static/media/image-4.5fc20a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/StateofSocial/image-4.jpg
// module id = 484
// module chunks = 0